import React, { useEffect, useState } from "react";
import axios, { API_BASE_URL } from "../api/axios";
import ImageLoader from "../common/ImageLoader";
import "./Our_Team.css";

const OurTeam = () => {
  const [years, setYears] = useState([]);
  const [selectedYearId, setSelectedYearId] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = API_BASE_URL;

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/ourteam");
      setYears(res.data || []);

      if (res.data && res.data.length > 0) {
        setSelectedYearId(res.data[0].id);
      }
    } catch (err) {
      console.error("Failed to fetch team:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleJoinNow = async () => {
    try {
      const res = await axios.get("/join-link");
      const data = res.data;
      if (data?.link) window.open(data.link, "_blank");
      else alert("Join link not found.");
    } catch (err) {
      console.error("Error fetching join link:", err);
      alert("Unable to open the join link right now.");
    }
  };

  const selectedYear = years.find((year) => year.id === selectedYearId);

  const formatPath = (path) => {
    if (!path) return "";
    return `${BASE_URL}/${path.replace(/\\/g, "/")}`;
  };

  if (loading) {
    return (
      <div className="our-team-container loading-page">
        <div className="loading-spinner"></div>
        <p>Loading chapter team history...</p>
      </div>
    );
  }

  return (
    <section id="ourteam" className="our-team-container">
      <div className="our-team-inner">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">✦ CHAPTER LEADERSHIP</span>
          <h1 className="section-main-title">Our Team &amp; History</h1>
          <p className="section-description">
            Meet the brilliant minds and student leaders behind the DIET ACM
            Student Chapter, year after year.
          </p>

          {/* Academic Year Selector Pills */}
          {years.length > 0 && (
            <div className="year-selector-wrapper">
              <div className="year-buttons">
                {years.map((year) => (
                  <button
                    key={year.id}
                    onClick={() => setSelectedYearId(year.id)}
                    className={`year-button ${selectedYearId === year.id ? "active" : ""}`}
                  >
                    <span>{year.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {selectedYear && (
          <div className="team-year-showcase">
            {/* 1. INSTITUTE COORDINATORS */}
            <div className="team-category-block">
              <div className="category-header">
                <span className="category-tag">FACULTY MENTORS</span>
                <h2 className="team-subheading">Institute Coordinators</h2>
              </div>

              <div className="team-grid coordinators-grid">
                {selectedYear.InstituteCoordinators?.map((member) => (
                  <div
                    className="member-card coordinator-card glass-panel glow-on-hover"
                    key={member.id}
                  >
                    <div className="coordinator-photo-wrapper">
                      <ImageLoader
                        src={formatPath(member.imagePath)}
                        alt={member.name}
                        className="coordinator-image"
                      />
                    </div>
                    <div className="member-info">
                      <h3 className="member-name">{member.name}</h3>
                      <p className="member-title">{member.title}</p>
                    </div>
                  </div>
                ))}
                {(!selectedYear.InstituteCoordinators ||
                  selectedYear.InstituteCoordinators.length === 0) && (
                  <p className="no-members-msg">
                    No institute coordinators listed for {selectedYear.label}.
                  </p>
                )}
              </div>
            </div>

            {/* 2. EXECUTIVE COMMITTEE MEMBERS */}
            <div className="team-category-block">
              <div className="category-header">
                <span className="category-tag">STUDENT LEADERS</span>
                <h2 className="team-subheading">Executive Committee Members</h2>
              </div>

              <div className="team-grid executive-grid">
                {selectedYear.ExecutiveCommitteeMembers?.map((member) => (
                  <div
                    className="member-card executive-card glass-panel glow-on-hover"
                    key={member.id}
                  >
                    <div className="executive-photo-wrapper">
                      <ImageLoader
                        src={formatPath(member.imagePath)}
                        alt={member.name}
                        className="executive-image"
                      />
                    </div>
                    <div className="member-info">
                      <h3 className="member-name">{member.name}</h3>
                      <span className="member-title-badge">{member.title}</span>
                    </div>
                  </div>
                ))}
                {(!selectedYear.ExecutiveCommitteeMembers ||
                  selectedYear.ExecutiveCommitteeMembers.length === 0) && (
                  <p className="no-members-msg">
                    No executive members listed for {selectedYear.label}.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Join Our Team Banner */}
        <div className="join-team-card glass-panel">
          <div className="join-team-content">
            <h3 className="join-team-title">Join Our Core Team</h3>
            <p className="join-team-text">
              Interested in shaping technical initiatives, organizing hackathons,
              and leading the DIET ACM Chapter? Become part of our leadership team!
            </p>
          </div>
          <button className="btn-join-team" onClick={handleJoinNow}>
            <i className="fas fa-paper-plane"></i>
            <span>Apply For Core Team</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;